import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-settings-teacher',
	templateUrl: './icon-settings-teacher.component.svg',
})
export class IconSettingsTeacherComponent {}
